
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "marketplace-storefront-public-ui",
  currentProjectVersion: "static-1.13517",
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13517",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.1136",
  "client-types": "static-1.510",
  "data-fetching-client": "static-1.10117",
  "foundations-components": "static-1.8754",
  "foundations-components-legacy": "static-1.1779",
  "foundations-theming": "static-1.4965",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.93",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8516",
  "hub-http-shared-msw-handlers": "static-1.10910",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11964",
  "I18n": "static-7.1708",
  "jasmine-runner": "static-1.6928",
  "marketplace-discovery-studio-lib": "static-1.911",
  "marketplace-storefront-base": "static-1.13580",
  "quartz": "static-1.7659",
  "react-dlb": "static-1.93",
  "react-rhumb": "static-1.17215",
  "reactive-variable-buffer-atom": "static-1.3330",
  "reporting-testing-lib": "static-1.11289",
  "reselect": "static-3.16",
  "settings-ui-lib": "static-1.13004",
  "SharedI18nStrings": "static-1.187",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7854",
  "ui-addon-i18n": "static-1.11622",
  "ui-addon-react-router-dom": "static-1.10002",
  "unified-auth": "static-1.1265",
  "unified-auth-core-lib": "static-1.1547",
  "usage-tracker": "static-1.7802",
  "usage-tracker-core": "static-1.7652",
  "customer-data-property-utils": "static-1.8527",
  "hub-http": "static-1.6683",
  "integrations-lib": "static-1.17436",
  "marketplace-ui-common": "static-1.21050",
  "marketplace-ui-install": "static-1.1036",
  "property-management-iframe": "static-1.14462",
  "quartz-config": "static-1.1437",
  "quartz-core": "static-1.6878",
  "quartz-routing": "static-1.1089",
  "quick-fetch": "static-1.4233",
  "react": "static-7.202",
  "rpc-client-utils": "static-1.5147",
  "ts-schema": "static-1.4395",
  "ui-universal-auth": "static-1.9751",
  "UIComponents": "static-3.8910",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3936",
  "quartz-webpack": "static-1.3883",
  "bend-plugin-quartz-routing": "static-1.737",
  "ai-components-ui-library": "static-1.10025",
  "codemirror": "static-5.106",
  "foundations-assets": "static-1.5362",
  "pulse": "static-1.1124",
  "react-codemirror": "static-1.11118",
  "ui-extensions-preview-lib": "static-1.970",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5023",
  "floating-ui": "static-1.68",
  "foundations-theming-specialty": "static-1.2681",
  "framer-motion": "static-1.84",
  "hs-story-utils": "static-1.9903",
  "react-aria": "static-1.77",
  "react-create-root-preference": "static-1.103",
  "react-select-plus": "static-1.118",
  "react-utils": "static-2.5658",
  "react-virtualized": "static-2.112",
  "StyleGuideUI": "static-3.518",
  "tanstack-table": "static-1.66",
  "trellis-assets": "static-1.3094",
  "ui-fonts": "static-1.1226",
  "ui-images": "static-2.1277",
  "bend-plugin-foundations-theming": "static-1.3448",
  "foundations-theming-base": "static-1.3950",
  "stylex": "static-1.46",
  "HeadJS": "static-2.822",
  "hs-test-utils-bend-plugin": "static-1.3627",
  "msw": "static-1.102",
  "msw-config": "static-1.29",
  "testing-library": "static-1.164",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.96",
  "jasmine": "static-4.4784",
  "ui-addon-video-player": "static-1.9101",
  "ai-rendering-library": "static-1.11406",
  "chirp-fetch": "static-1.2381",
  "connections-embed-lib": "static-1.1755",
  "copilot-toolkit": "static-1.12156",
  "feedback-loader": "static-1.30067",
  "laboratory-lib": "static-3.7624",
  "marketplace-embed": "static-1.23209",
  "marketplace-ui-details": "static-1.10945",
  "marketplace-ui-reviews": "static-1.21005",
  "marketplace-ui-tracking": "static-1.15220",
  "sanitize-text": "static-1.8635",
  "usage-tracker-multi": "static-1.6216",
  "usage-tracker-session-replay": "static-1.5488",
  "beacon-keepalive-queue": "static-1.177",
  "quartz-head": "static-1.1324",
  "web-vitals": "static-1.19",
  "apollo-link-hub-http": "static-2.5064",
  "immer": "static-1.105",
  "immerable": "static-1.4618",
  "highcharts": "static-8.115",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2837",
  "reporting-data": "static-1.69356",
  "cssUtils": "static-1.1099",
  "flux-actions": "static-1.380",
  "react-colorpicker": "static-2.10687",
  "react-dnd-compat": "static-1.5086",
  "redux-observable": "static-1.79",
  "ReduxMessenger": "static-2.10848",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7792",
  "icons": "static-2.703",
  "marketplace-ui-apps-core": "static-1.19582",
  "storybook-react": "static-1.44",
  "trellis-story-utils": "static-1.4975",
  "foundations-components-test-utils": "static-1.6237",
  "quartz-i18n": "static-1.1334",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.770",
  "ads-unified-auth-lib": "static-1.1982",
  "ai-mcp-auth-lib": "static-1.20",
  "custom-vendor-connection-lib": "static-1.315",
  "google-sheets-integration-lib": "static-1.1338",
  "microsoft-drive-auth-lib": "static-1.515",
  "slack-ui-library": "static-1.10875",
  "surveymonkey-integration-lib": "static-1.873",
  "fsm": "static-1.4234",
  "customer-data-objects": "static-1.8180",
  "property-translator": "static-1.5857",
  "hs-locale-management": "static-1.402",
  "frontend-preferences-client": "static-1.8397",
  "hs-promise-utils": "static-1.6069",
  "hubspot-apollo-client": "static-1.5357",
  "integrations-error-boundary-lib": "static-1.14851",
  "integrations-tracking-lib": "static-1.6097",
  "native-integrations-shared-strings": "static-1.8241",
  "sanitize": "static-1.4951",
  "superstore": "static-1.5237",
  "ui-shepherd-react": "static-3.10756",
  "ai-settings-ui-library": "static-1.8591",
  "hub-http-janus": "static-1.907",
  "hubspotter-http": "static-1.4977",
  "immutable-less": "static-1.5129",
  "marketplace-ui-client-types": "static-1.18457",
  "nav-meta": "static-1.30810",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18547",
  "ui-product-approvals-common": "static-1.1588",
  "ai-studio-lib": "static-1.12771",
  "hubspot-prosemirror": "static-1.19286",
  "integrations-reconnect-lib": "static-1.728",
  "ui-addon-iframeable": "static-1.9553",
  "ui-addon-integrations-directory-panel": "static-2.8430",
  "ui-product-approvals": "static-1.29693",
  "ui-tool-access": "static-1.10637",
  "inbound-db-properties-service-client": "static-1.4153",
  "property-management-common": "static-1.6750",
  "opentelemetry-fe-types": "static-1.268",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.606",
  "module-federation": "static-1.38",
  "opentelemetry-fe": "static-1.643",
  "quartz-auth": "static-1.1334",
  "quartz-test": "static-1.1334",
  "quartz-tracking": "static-1.1038",
  "trellis-components": "static-1.3113",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.557",
  "HubStyle": "static-2.12271",
  "bender-build-tools": "static-1.3592",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23902",
  "ContentUtils": "static-1.69478",
  "customer-data-objects-ui-components": "static-1.13512",
  "sassPrefix": "static-1.365",
  "diff-match-patch": "static-1.7",
  "batch-promise": "static-1.2026",
  "bend-plugin-pulse": "static-1.627",
  "event-emitter": "static-1.1438",
  "fast-json-patch": "static-1.74",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5909",
  "magpie-types": "static-1.5369",
  "stylex-utils": "static-1.175",
  "trellis-theming": "static-1.1483",
  "avatar-components": "static-1.2962",
  "breeze-engine-core": "static-1.1470",
  "breeze-engine-lib": "static-1.2192",
  "breeze-onboarding-components": "static-1.1071",
  "customer-data-filters-ui": "static-1.41368",
  "customer-data-reference-ui-components": "static-1.13652",
  "data-integrations-breeze": "static-1.319",
  "embedded-academy-lib": "static-1.16015",
  "ExportDialog": "static-6.10851",
  "global-styles-ai-lib": "static-1.495",
  "highlight.js": "static-1.90",
  "marketplace-embed-ba": "static-1.912",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.44",
  "reporting-action-components": "static-1.42414",
  "reporting-snowflake": "static-1.57972",
  "reporting-ui-components": "static-2.66625",
  "reporting-visualizations": "static-1.61430",
  "trial-components-library": "static-1.14381",
  "ui-addon-teams": "static-1.22014",
  "upgrade-components-lib": "static-1.720",
  "navigation-components": "static-1.19173",
  "nest": "static-1.713",
  "simple-logging-lib": "static-1.3528",
  "nudge-client-utils": "static-1.3428",
  "fail-safe": "static-1.426",
  "app-governance-lib": "static-1.2740",
  "developer-experience-shared-components": "static-1.11016",
  "purchase-motions-components": "static-1.6636",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10796",
  "usage-tracker-anonymous": "static-1.6219",
  "usage-tracker-public": "static-1.7613",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3776",
  "persist-promise": "static-1.4183",
  "reference-resolvers": "static-1.8660",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4393",
  "hubspot-apollo-cache": "static-1.816",
  "universal-page-editor-lib": "static-1.3488",
  "final-form": "static-1.83",
  "redux-toolkit": "static-1.82",
  "simple-data-table": "static-1.3829",
  "merchandise-lib": "static-1.284",
  "onboarding-scopes": "static-1.6929",
  "ui-addon-draggable": "static-3.5225",
  "content-assistance-lib": "static-1.8427",
  "content-media-capture": "static-1.5800",
  "customer-data-ui-utilities": "static-1.10308",
  "emoji-mart": "static-3.7",
  "file-manager-components": "static-1.24849",
  "growth-payments-core": "static-1.26509",
  "knowledge-content-types": "static-1.8763",
  "PatternValidationJS": "static-1.3362",
  "payment-link-components": "static-1.24462",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20560",
  "ui-addon-emoji-picker": "static-1.10341",
  "ui-business-units-lib": "static-1.9573",
  "video-components-external": "static-1.12436",
  "video-data-lib": "static-1.36094",
  "navigation-messaging": "static-1.8500",
  "collaboration-sidebar": "static-1.59060",
  "trellis-ext-dnd": "static-1.550",
  "crm-component-utils": "static-1.40196",
  "crm-properties-common-lib": "static-1.6372",
  "customer-data-properties": "static-1.53056",
  "external-options-client-types": "static-1.4441",
  "framework-data-schema-resolvers": "static-1.7370",
  "hs-resources": "static-1.667",
  "property-value-citations": "static-1.3670",
  "reference-resolvers-lite": "static-1.8590",
  "opentelemetry-web": "static-1.22",
  "hubspotter-http-shared-msw-handlers": "static-1.10908",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.15",
  "tanstack-virtual": "static-1.43",
  "cms-field-types": "static-1.5287",
  "content-icons-ui": "static-1.2458",
  "atom": "static-1.5550",
  "idb-keyval": "static-1.55",
  "reactive-lib": "static-1.1197",
  "trellis-migration-context": "static-1.57",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1170",
  "breeze-artifacts-sdk": "static-1.964",
  "getting-started-shared-tasks": "static-1.19570",
  "onboarding-journeys-lib": "static-1.1240",
  "conversations-skeleton-state": "static-1.7608",
  "crm-message-bus": "static-1.44112",
  "customer-data-filters-ui-msw-helpers": "static-1.23803",
  "events-data-lib": "static-1.722",
  "FormUrlGenerator": "static-2.5189",
  "framework-builder-read-service-client": "static-1.4337",
  "multi-account-reference-resolvers": "static-1.1486",
  "onboarding-tours": "static-1.17410",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14776",
  "segments-client-types": "static-1.12156",
  "academy-common-lib": "static-1.15476",
  "dashboard-lib": "static-1.83315",
  "hubspot-prosemirror-plugins": "static-1.19278",
  "share-with-third-party-component-lib": "static-1.9189",
  "ui-asset-management-lib": "static-1.11577",
  "user-context": "static-1.5531",
  "reporting-plugins": "static-1.10991",
  "reporting-reports": "static-1.69032",
  "hubs-service-types": "static-1.1746",
  "purchase-motions-api": "static-1.6639",
  "salesImages": "static-1.734",
  "signup-constants": "static-1.19949",
  "nudge-custom-function-registry": "static-1.3185",
  "nudge-renderer-utils": "static-1.3504",
  "whisper-core-api": "static-1.7642",
  "bend-plugin-fail-safe": "static-1.377",
  "framework-listing-lib": "static-2.29804",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31765",
  "apps-service-types": "static-1.4096",
  "oauth-service-types": "static-1.4615",
  "signup-ui-url-generator": "static-2.8520",
  "onboarding-tours-client": "static-1.5625",
  "one-click-checkout": "static-1.749",
  "platform-infra-nav-components": "static-1.8004",
  "subscription-experience-data-types": "static-1.15438",
  "crm-record-cards-service-types": "static-1.3871",
  "location-customization-utils-lib": "static-1.10426",
  "redux-thunk": "static-2.84",
  "react-flip-move": "static-1.83",
  "ui-coaching-tips": "static-1.29585",
  "content-media-composition-data-lib": "static-1.13604",
  "fix-webm-duration": "static-1.34",
  "notification-sounds": "static-1.4905",
  "react-immutable-render-mixin": "static-1.9",
  "poll-commands": "static-1.3955",
  "seat-types-lib": "static-1.1059",
  "ui-addon-opt": "static-4.8886",
  "commerce-tours-lib": "static-1.6868",
  "growth-onboarding-reliability": "static-1.5560",
  "sales-checkout-service-client": "static-1.3999",
  "data-token-picker": "static-1.17140",
  "FileManagerLib": "static-1.40489",
  "content-media-compositions": "static-2.17611",
  "media-bridge-lib": "static-1.19648",
  "chatspot-widget-iframe": "static-1.23893",
  "collaboration-sidebar-common": "static-1.3857",
  "marketing-platform-lib": "static-1.7384",
  "dnd-kit": "static-1.21",
  "commerce-subscription-lib": "static-1.38061",
  "crm-actions": "static-1.6849",
  "crm-cards-sdk": "static-1.45030",
  "customer-data-properties-shared-msw-handlers": "static-1.10237",
  "customer-data-tracking": "static-1.7348",
  "calling-global-api": "static-1.66204",
  "calling-internal-common": "static-1.31802",
  "calling-lifecycle-internal": "static-1.67586",
  "calling-lifecycle-messages": "static-1.59878",
  "commerce-products-lib": "static-1.10925",
  "conditional-properties-service-client": "static-1.4115",
  "crm-index-visualization-core": "static-1.4760",
  "crm-links": "static-1.6787",
  "crm-pipelines-api-client-types": "static-1.4445",
  "formula-editor": "static-1.15017",
  "google-libphonenumber": "static-1.49",
  "inbounddb-objects-service-types": "static-1.4521",
  "meetings-icalendar-utils-lib": "static-1.1109",
  "multi-currency-client-types": "static-1.4009",
  "object-builder-ui-client": "static-1.50055",
  "pipeline-validation-client-types": "static-1.4283",
  "smart-data-capture-core": "static-1.479",
  "smart-property-lib": "static-1.8664",
  "tiered-pricing": "static-1.2285",
  "topics-actions-lib": "static-1.659",
  "trellis-ext-i18n": "static-1.1394",
  "ui-addon-form-validation": "static-1.11348",
  "zustand": "static-1.89",
  "fdsr-migration-layer": "static-1.489",
  "framework-data-schema-quick-fetch": "static-1.7275",
  "restore-request-side-panel-lib": "static-1.2034",
  "growth-data-modal": "static-1.6139",
  "growth-onboarding-confetti": "static-1.3536",
  "growth-onboarding-next-action-utils": "static-1.2990",
  "onboarding-tours-utils": "static-1.1477",
  "ui-shepherd-tracker": "static-1.8137",
  "crm-index-associations-lib": "static-1.6925",
  "academy-service-client": "static-1.4169",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40348",
  "SafeStorage": "static-1.4874",
  "video-embed": "static-1.36928",
  "wootric-nps": "static-1.7298",
  "redux-actions": "static-3.74",
  "EmailSignatureEditor": "static-1.25254",
  "viral-links-lib": "static-1.7558",
  "nested-table": "static-1.709",
  "timezone-utils": "static-2.5707",
  "getting-started-shared-tasks-store": "static-1.18688",
  "campaign-roi-lib": "static-1.10833",
  "campaigns-utils-lib": "static-1.3724",
  "ui-addon-calendars": "static-2.5842",
  "customer-data-views-management": "static-1.26361",
  "framework-data-table": "static-2.12844",
  "nudge-custom-ui-functions": "static-1.1745",
  "switchboard-lib": "static-1.713",
  "access-check-ui-lib": "static-1.1889",
  "app-users-service-client": "static-1.6098",
  "app-users-service-types": "static-1.5506",
  "mini-checkout-client": "static-1.27844",
  "onboarding-utils": "static-1.5850",
  "permissions-shared-i18n-strings-fe": "static-1.2143",
  "ui-coaching-tips-shared-config": "static-1.29570",
  "checkout-sdk": "static-3.24687",
  "payment-method-components": "static-1.7319",
  "touchless-buying-components": "static-1.6555",
  "upgrade-catalog-service-types": "static-1.3901",
  "edison-service-client-types": "static-1.868",
  "growth-onboarding-feedback-components": "static-1.7057",
  "audio-components": "static-1.6576",
  "FileManagerImages": "static-1.38000",
  "video-components": "static-1.14438",
  "js-cookie": "static-1.18",
  "commerce-billing-lib": "static-1.20495",
  "commerce-shared-components-lib": "static-1.19572",
  "commerce-tools-ui-lib": "static-1.11328",
  "crm_data": "static-4.93213",
  "crm-activity-creator-data": "static-1.47732",
  "crm-fe-perf": "static-1.23377",
  "universal-record-utils-lib": "static-1.2371",
  "calling-error-reporting": "static-1.31809",
  "shared-worker-versioning": "static-1.11519",
  "calling-usage-tracker": "static-1.7016",
  "voice-sms-access-library": "static-1.2457",
  "commerce-permissions": "static-1.1261",
  "products-iframe-lib": "static-1.8913",
  "products-ui-components-shared-msw-handlers": "static-1.11292",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10993",
  "sales-views-client-types": "static-1.4735",
  "bark-lib": "static-1.17008",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.922",
  "data-agent-test-utils": "static-1.466",
  "data-agent-utils": "static-1.935",
  "policy-lib": "static-1.7282",
  "react-tinymce": "static-1.56275",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11056",
  "tinymce-config": "static-2.55401",
  "tinymce-plugins": "static-1.58515",
  "onboarding-data-sync-lib": "static-1.2845",
  "growth-onboarding-next-action-components": "static-1.3018",
  "user-context-client": "static-1.4986",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.65",
  "urlinator": "static-1.4991",
  "outpost": "static-1.4605",
  "draft-convert": "static-2.84",
  "draft-extend": "static-3.88",
  "draft-js": "static-5.90",
  "draft-plugins": "static-2.22363",
  "sales-email-signature-service-client": "static-1.4325",
  "ts-utils-lib": "static-1.628",
  "copilot-messaging": "static-1.2406",
  "crm-export-dialog": "static-1.6756",
  "crm-index-ui-shimmer": "static-1.2975",
  "crm-view-components": "static-1.1495",
  "react-beautiful-dnd": "static-1.75",
  "customer-data-associations": "static-1.7815",
  "tasks-actions-lib": "static-1.439",
  "InboxConnectUtils": "static-4.15849",
  "emoji-regex": "static-1.7",
  "hub-http-rxjs": "static-1.879",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4464",
  "company-details-components": "static-1.6683",
  "react-performance-metrics-lib": "static-1.1030",
  "pricing-pages-ui-components": "static-1.16566",
  "quote-checkout-service-types": "static-1.3936",
  "social-insights-client-types": "static-1.22938",
  "utility-belt": "static-1.3014",
  "payments-enrollment-embed-lib": "static-1.24211",
  "stripe-embedded-components": "static-1.8251",
  "customer-data-rte": "static-1.33907",
  "cv-backend-services": "static-1.1607",
  "growth-onboarding-empty-states": "static-1.6540",
  "payments-post-enroll-local-storage-lib": "static-1.5581",
  "qrcode-generator": "static-1.80",
  "quotes-client-types": "static-1.39176",
  "crm_universal": "static-1.22731",
  "customer-data-email": "static-1.18647",
  "meetings-rte-lib": "static-1.548",
  "universal-associations-select": "static-1.11572",
  "crm-object-search-query-utilities": "static-1.10464",
  "calling-orchestration-schema": "static-1.37234",
  "react-reducer-toolkit": "static-1.16675",
  "enrichment-settings-lib": "static-1.240",
  "tinymce": "static-5.11",
  "tinymce-themes": "static-1.57371",
  "hub-http-contrib": "static-1.3510",
  "interframe": "static-3.5218",
  "tinymce-data": "static-1.41486",
  "ui-addon-sales-email": "static-1.5678",
  "layout-dnd-components": "static-1.13234",
  "layout-dnd-utils": "static-1.12209",
  "ui-brand-identity-lib": "static-1.16955",
  "meetings-connect-utils-lib": "static-1.8096",
  "company-details-service-types": "static-1.4422",
  "segments-query-core": "static-1.1907",
  "pricing-pages-api": "static-1.16431",
  "stripe-connect-js": "static-1.82",
  "draft-content-plugins": "static-1.29162",
  "sequences-lib": "static-1.8792",
  "ui-gdpr-components": "static-1.10656",
  "meetings-client-types": "static-1.4066",
  "meetings-core": "static-1.770",
  "NamespacedHubStyle": "static-2.9369",
  "ContentData": "static-1.69553",
  "layout-data-lib": "static-1.10534",
  "sequences-client-types-lib": "static-1.8649",
  "advanced-menus-core": "static-1.15821",
  "advanced-menus-lib": "static-1.12572",
  "ui-memberships-settings-lib": "static-1.35201",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15820",
  "simple-menus-lib": "static-1.17337"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13517",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.1136",
  "client-types": "/client-types/static-1.510",
  "data-fetching-client": "/data-fetching-client/static-1.10117",
  "foundations-components": "/foundations-components/static-1.8754",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1779",
  "foundations-theming": "/foundations-theming/static-1.4965",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.93",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8516",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10910",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11964",
  "I18n": "/I18n/static-7.1708",
  "jasmine-runner": "/jasmine-runner/static-1.6928",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.911",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13580",
  "quartz": "/quartz/static-1.7659",
  "react-dlb": "/react-dlb/static-1.93",
  "react-rhumb": "/react-rhumb/static-1.17215",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3330",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11289",
  "reselect": "/reselect/static-3.16",
  "settings-ui-lib": "/settings-ui-lib/static-1.13004",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7854",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11622",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10002",
  "unified-auth": "/unified-auth/static-1.1265",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1547",
  "usage-tracker": "/usage-tracker/static-1.7802",
  "usage-tracker-core": "/usage-tracker-core/static-1.7652",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8527",
  "hub-http": "/hub-http/static-1.6683",
  "integrations-lib": "/integrations-lib/static-1.17436",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21050",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.1036",
  "property-management-iframe": "/property-management-iframe/static-1.14462",
  "quartz-config": "/quartz-config/static-1.1437",
  "quartz-core": "/quartz-core/static-1.6878",
  "quartz-routing": "/quartz-routing/static-1.1089",
  "quick-fetch": "/quick-fetch/static-1.4233",
  "react": "/react/static-7.202",
  "rpc-client-utils": "/rpc-client-utils/static-1.5147",
  "ts-schema": "/ts-schema/static-1.4395",
  "ui-universal-auth": "/ui-universal-auth/static-1.9751",
  "UIComponents": "/UIComponents/static-3.8910",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3936",
  "quartz-webpack": "/quartz-webpack/static-1.3883",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.737",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10025",
  "codemirror": "/codemirror/static-5.106",
  "foundations-assets": "/foundations-assets/static-1.5362",
  "pulse": "/pulse/static-1.1124",
  "react-codemirror": "/react-codemirror/static-1.11118",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.970",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5023",
  "floating-ui": "/floating-ui/static-1.68",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2681",
  "framer-motion": "/framer-motion/static-1.84",
  "hs-story-utils": "/hs-story-utils/static-1.9903",
  "react-aria": "/react-aria/static-1.77",
  "react-create-root-preference": "/react-create-root-preference/static-1.103",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-utils": "/react-utils/static-2.5658",
  "react-virtualized": "/react-virtualized/static-2.112",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "tanstack-table": "/tanstack-table/static-1.66",
  "trellis-assets": "/trellis-assets/static-1.3094",
  "ui-fonts": "/ui-fonts/static-1.1226",
  "ui-images": "/ui-images/static-2.1277",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3448",
  "foundations-theming-base": "/foundations-theming-base/static-1.3950",
  "stylex": "/stylex/static-1.46",
  "HeadJS": "/HeadJS/static-2.822",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3627",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.29",
  "testing-library": "/testing-library/static-1.164",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.96",
  "jasmine": "/jasmine/static-4.4784",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9101",
  "ai-rendering-library": "/ai-rendering-library/static-1.11406",
  "chirp-fetch": "/chirp-fetch/static-1.2381",
  "connections-embed-lib": "/connections-embed-lib/static-1.1755",
  "copilot-toolkit": "/copilot-toolkit/static-1.12156",
  "feedback-loader": "/feedback-loader/static-1.30067",
  "laboratory-lib": "/laboratory-lib/static-3.7624",
  "marketplace-embed": "/marketplace-embed/static-1.23209",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10945",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.21005",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15220",
  "sanitize-text": "/sanitize-text/static-1.8635",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6216",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5488",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.177",
  "quartz-head": "/quartz-head/static-1.1324",
  "web-vitals": "/web-vitals/static-1.19",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5064",
  "immer": "/immer/static-1.105",
  "immerable": "/immerable/static-1.4618",
  "highcharts": "/highcharts/static-8.115",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2837",
  "reporting-data": "/reporting-data/static-1.69356",
  "cssUtils": "/cssUtils/static-1.1099",
  "flux-actions": "/flux-actions/static-1.380",
  "react-colorpicker": "/react-colorpicker/static-2.10687",
  "react-dnd-compat": "/react-dnd-compat/static-1.5086",
  "redux-observable": "/redux-observable/static-1.79",
  "ReduxMessenger": "/ReduxMessenger/static-2.10848",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7792",
  "icons": "/icons/static-2.703",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19582",
  "storybook-react": "/storybook-react/static-1.44",
  "trellis-story-utils": "/trellis-story-utils/static-1.4975",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6237",
  "quartz-i18n": "/quartz-i18n/static-1.1334",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.770",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1982",
  "ai-mcp-auth-lib": "/ai-mcp-auth-lib/static-1.20",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.315",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1338",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.515",
  "slack-ui-library": "/slack-ui-library/static-1.10875",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.873",
  "fsm": "/fsm/static-1.4234",
  "customer-data-objects": "/customer-data-objects/static-1.8180",
  "property-translator": "/property-translator/static-1.5857",
  "hs-locale-management": "/hs-locale-management/static-1.402",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8397",
  "hs-promise-utils": "/hs-promise-utils/static-1.6069",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5357",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14851",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6097",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8241",
  "sanitize": "/sanitize/static-1.4951",
  "superstore": "/superstore/static-1.5237",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10756",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8591",
  "hub-http-janus": "/hub-http-janus/static-1.907",
  "hubspotter-http": "/hubspotter-http/static-1.4977",
  "immutable-less": "/immutable-less/static-1.5129",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18457",
  "nav-meta": "/nav-meta/static-1.30810",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18547",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1588",
  "ai-studio-lib": "/ai-studio-lib/static-1.12771",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19286",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.728",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9553",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8430",
  "ui-product-approvals": "/ui-product-approvals/static-1.29693",
  "ui-tool-access": "/ui-tool-access/static-1.10637",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4153",
  "property-management-common": "/property-management-common/static-1.6750",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.268",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.606",
  "module-federation": "/module-federation/static-1.38",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.643",
  "quartz-auth": "/quartz-auth/static-1.1334",
  "quartz-test": "/quartz-test/static-1.1334",
  "quartz-tracking": "/quartz-tracking/static-1.1038",
  "trellis-components": "/trellis-components/static-1.3113",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.557",
  "HubStyle": "/HubStyle/static-2.12271",
  "bender-build-tools": "/bender-build-tools/static-1.3592",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23902",
  "ContentUtils": "/ContentUtils/static-1.69478",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13512",
  "sassPrefix": "/sassPrefix/static-1.365",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "batch-promise": "/batch-promise/static-1.2026",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.627",
  "event-emitter": "/event-emitter/static-1.1438",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5909",
  "magpie-types": "/magpie-types/static-1.5369",
  "stylex-utils": "/stylex-utils/static-1.175",
  "trellis-theming": "/trellis-theming/static-1.1483",
  "avatar-components": "/avatar-components/static-1.2962",
  "breeze-engine-core": "/breeze-engine-core/static-1.1470",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2192",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.1071",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41368",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13652",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.319",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16015",
  "ExportDialog": "/ExportDialog/static-6.10851",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.495",
  "highlight.js": "/highlight.js/static-1.90",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.912",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.44",
  "reporting-action-components": "/reporting-action-components/static-1.42414",
  "reporting-snowflake": "/reporting-snowflake/static-1.57972",
  "reporting-ui-components": "/reporting-ui-components/static-2.66625",
  "reporting-visualizations": "/reporting-visualizations/static-1.61430",
  "trial-components-library": "/trial-components-library/static-1.14381",
  "ui-addon-teams": "/ui-addon-teams/static-1.22014",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.720",
  "navigation-components": "/navigation-components/static-1.19173",
  "nest": "/nest/static-1.713",
  "simple-logging-lib": "/simple-logging-lib/static-1.3528",
  "nudge-client-utils": "/nudge-client-utils/static-1.3428",
  "fail-safe": "/fail-safe/static-1.426",
  "app-governance-lib": "/app-governance-lib/static-1.2740",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11016",
  "purchase-motions-components": "/purchase-motions-components/static-1.6636",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10796",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6219",
  "usage-tracker-public": "/usage-tracker-public/static-1.7613",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3776",
  "persist-promise": "/persist-promise/static-1.4183",
  "reference-resolvers": "/reference-resolvers/static-1.8660",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4393",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.816",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3488",
  "final-form": "/final-form/static-1.83",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "simple-data-table": "/simple-data-table/static-1.3829",
  "merchandise-lib": "/merchandise-lib/static-1.284",
  "onboarding-scopes": "/onboarding-scopes/static-1.6929",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5225",
  "content-assistance-lib": "/content-assistance-lib/static-1.8427",
  "content-media-capture": "/content-media-capture/static-1.5800",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10308",
  "emoji-mart": "/emoji-mart/static-3.7",
  "file-manager-components": "/file-manager-components/static-1.24849",
  "growth-payments-core": "/growth-payments-core/static-1.26509",
  "knowledge-content-types": "/knowledge-content-types/static-1.8763",
  "PatternValidationJS": "/PatternValidationJS/static-1.3362",
  "payment-link-components": "/payment-link-components/static-1.24462",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20560",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10341",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9573",
  "video-components-external": "/video-components-external/static-1.12436",
  "video-data-lib": "/video-data-lib/static-1.36094",
  "navigation-messaging": "/navigation-messaging/static-1.8500",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.59060",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.550",
  "crm-component-utils": "/crm-component-utils/static-1.40196",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6372",
  "customer-data-properties": "/customer-data-properties/static-1.53056",
  "external-options-client-types": "/external-options-client-types/static-1.4441",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7370",
  "hs-resources": "/hs-resources/static-1.667",
  "property-value-citations": "/property-value-citations/static-1.3670",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8590",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10908",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.15",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "cms-field-types": "/cms-field-types/static-1.5287",
  "content-icons-ui": "/content-icons-ui/static-1.2458",
  "atom": "/atom/static-1.5550",
  "idb-keyval": "/idb-keyval/static-1.55",
  "reactive-lib": "/reactive-lib/static-1.1197",
  "trellis-migration-context": "/trellis-migration-context/static-1.57",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1170",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.964",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19570",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1240",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7608",
  "crm-message-bus": "/crm-message-bus/static-1.44112",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23803",
  "events-data-lib": "/events-data-lib/static-1.722",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5189",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4337",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1486",
  "onboarding-tours": "/onboarding-tours/static-1.17410",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14776",
  "segments-client-types": "/segments-client-types/static-1.12156",
  "academy-common-lib": "/academy-common-lib/static-1.15476",
  "dashboard-lib": "/dashboard-lib/static-1.83315",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19278",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9189",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11577",
  "user-context": "/user-context/static-1.5531",
  "reporting-plugins": "/reporting-plugins/static-1.10991",
  "reporting-reports": "/reporting-reports/static-1.69032",
  "hubs-service-types": "/hubs-service-types/static-1.1746",
  "purchase-motions-api": "/purchase-motions-api/static-1.6639",
  "salesImages": "/salesImages/static-1.734",
  "signup-constants": "/signup-constants/static-1.19949",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3185",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3504",
  "whisper-core-api": "/whisper-core-api/static-1.7642",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.377",
  "framework-listing-lib": "/framework-listing-lib/static-2.29804",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31765",
  "apps-service-types": "/apps-service-types/static-1.4096",
  "oauth-service-types": "/oauth-service-types/static-1.4615",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8520",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5625",
  "one-click-checkout": "/one-click-checkout/static-1.749",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.8004",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15438",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10426",
  "redux-thunk": "/redux-thunk/static-2.84",
  "react-flip-move": "/react-flip-move/static-1.83",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29585",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13604",
  "fix-webm-duration": "/fix-webm-duration/static-1.34",
  "notification-sounds": "/notification-sounds/static-1.4905",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "poll-commands": "/poll-commands/static-1.3955",
  "seat-types-lib": "/seat-types-lib/static-1.1059",
  "ui-addon-opt": "/ui-addon-opt/static-4.8886",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6868",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5560",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3999",
  "data-token-picker": "/data-token-picker/static-1.17140",
  "FileManagerLib": "/FileManagerLib/static-1.40489",
  "content-media-compositions": "/content-media-compositions/static-2.17611",
  "media-bridge-lib": "/media-bridge-lib/static-1.19648",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23893",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3857",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7384",
  "dnd-kit": "/dnd-kit/static-1.21",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38061",
  "crm-actions": "/crm-actions/static-1.6849",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.45030",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10237",
  "customer-data-tracking": "/customer-data-tracking/static-1.7348",
  "calling-global-api": "/calling-global-api/static-1.66204",
  "calling-internal-common": "/calling-internal-common/static-1.31802",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67586",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59878",
  "commerce-products-lib": "/commerce-products-lib/static-1.10925",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4115",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4760",
  "crm-links": "/crm-links/static-1.6787",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4445",
  "formula-editor": "/formula-editor/static-1.15017",
  "google-libphonenumber": "/google-libphonenumber/static-1.49",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4521",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1109",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4009",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50055",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4283",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.479",
  "smart-property-lib": "/smart-property-lib/static-1.8664",
  "tiered-pricing": "/tiered-pricing/static-1.2285",
  "topics-actions-lib": "/topics-actions-lib/static-1.659",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1394",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11348",
  "zustand": "/zustand/static-1.89",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.489",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7275",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2034",
  "growth-data-modal": "/growth-data-modal/static-1.6139",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3536",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2990",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1477",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8137",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6925",
  "academy-service-client": "/academy-service-client/static-1.4169",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40348",
  "SafeStorage": "/SafeStorage/static-1.4874",
  "video-embed": "/video-embed/static-1.36928",
  "wootric-nps": "/wootric-nps/static-1.7298",
  "redux-actions": "/redux-actions/static-3.74",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25254",
  "viral-links-lib": "/viral-links-lib/static-1.7558",
  "nested-table": "/nested-table/static-1.709",
  "timezone-utils": "/timezone-utils/static-2.5707",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18688",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10833",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3724",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5842",
  "customer-data-views-management": "/customer-data-views-management/static-1.26361",
  "framework-data-table": "/framework-data-table/static-2.12844",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1745",
  "switchboard-lib": "/switchboard-lib/static-1.713",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1889",
  "app-users-service-client": "/app-users-service-client/static-1.6098",
  "app-users-service-types": "/app-users-service-types/static-1.5506",
  "mini-checkout-client": "/mini-checkout-client/static-1.27844",
  "onboarding-utils": "/onboarding-utils/static-1.5850",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2143",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29570",
  "checkout-sdk": "/checkout-sdk/static-3.24687",
  "payment-method-components": "/payment-method-components/static-1.7319",
  "touchless-buying-components": "/touchless-buying-components/static-1.6555",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3901",
  "edison-service-client-types": "/edison-service-client-types/static-1.868",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7057",
  "audio-components": "/audio-components/static-1.6576",
  "FileManagerImages": "/FileManagerImages/static-1.38000",
  "video-components": "/video-components/static-1.14438",
  "js-cookie": "/js-cookie/static-1.18",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20495",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19572",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11328",
  "crm_data": "/crm_data/static-4.93213",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.47732",
  "crm-fe-perf": "/crm-fe-perf/static-1.23377",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2371",
  "calling-error-reporting": "/calling-error-reporting/static-1.31809",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11519",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7016",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2457",
  "commerce-permissions": "/commerce-permissions/static-1.1261",
  "products-iframe-lib": "/products-iframe-lib/static-1.8913",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11292",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10993",
  "sales-views-client-types": "/sales-views-client-types/static-1.4735",
  "bark-lib": "/bark-lib/static-1.17008",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.922",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.466",
  "data-agent-utils": "/data-agent-utils/static-1.935",
  "policy-lib": "/policy-lib/static-1.7282",
  "react-tinymce": "/react-tinymce/static-1.56275",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11056",
  "tinymce-config": "/tinymce-config/static-2.55401",
  "tinymce-plugins": "/tinymce-plugins/static-1.58515",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2845",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3018",
  "user-context-client": "/user-context-client/static-1.4986",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.65",
  "urlinator": "/urlinator/static-1.4991",
  "outpost": "/outpost/static-1.4605",
  "draft-convert": "/draft-convert/static-2.84",
  "draft-extend": "/draft-extend/static-3.88",
  "draft-js": "/draft-js/static-5.90",
  "draft-plugins": "/draft-plugins/static-2.22363",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4325",
  "ts-utils-lib": "/ts-utils-lib/static-1.628",
  "copilot-messaging": "/copilot-messaging/static-1.2406",
  "crm-export-dialog": "/crm-export-dialog/static-1.6756",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2975",
  "crm-view-components": "/crm-view-components/static-1.1495",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.75",
  "customer-data-associations": "/customer-data-associations/static-1.7815",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.439",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15849",
  "emoji-regex": "/emoji-regex/static-1.7",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.879",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4464",
  "company-details-components": "/company-details-components/static-1.6683",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.1030",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16566",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3936",
  "social-insights-client-types": "/social-insights-client-types/static-1.22938",
  "utility-belt": "/utility-belt/static-1.3014",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24211",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8251",
  "customer-data-rte": "/customer-data-rte/static-1.33907",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6540",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5581",
  "qrcode-generator": "/qrcode-generator/static-1.80",
  "quotes-client-types": "/quotes-client-types/static-1.39176",
  "crm_universal": "/crm_universal/static-1.22731",
  "customer-data-email": "/customer-data-email/static-1.18647",
  "meetings-rte-lib": "/meetings-rte-lib/static-1.548",
  "universal-associations-select": "/universal-associations-select/static-1.11572",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10464",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37234",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16675",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.240",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-themes": "/tinymce-themes/static-1.57371",
  "hub-http-contrib": "/hub-http-contrib/static-1.3510",
  "interframe": "/interframe/static-3.5218",
  "tinymce-data": "/tinymce-data/static-1.41486",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5678",
  "layout-dnd-components": "/layout-dnd-components/static-1.13234",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12209",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16955",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8096",
  "company-details-service-types": "/company-details-service-types/static-1.4422",
  "segments-query-core": "/segments-query-core/static-1.1907",
  "pricing-pages-api": "/pricing-pages-api/static-1.16431",
  "stripe-connect-js": "/stripe-connect-js/static-1.82",
  "draft-content-plugins": "/draft-content-plugins/static-1.29162",
  "sequences-lib": "/sequences-lib/static-1.8792",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10656",
  "meetings-client-types": "/meetings-client-types/static-1.4066",
  "meetings-core": "/meetings-core/static-1.770",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9369",
  "ContentData": "/ContentData/static-1.69553",
  "layout-data-lib": "/layout-data-lib/static-1.10534",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8649",
  "advanced-menus-core": "/advanced-menus-core/static-1.15821",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12572",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35201",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15820",
  "simple-menus-lib": "/simple-menus-lib/static-1.17337"
}
};
